import { apiClient } from '@/shared/data/client';
import { mapCoverageFileDto, mapQueryResult } from '@/shared/data/dtoMappers';
import type {
  CoverageFileDto,
  CoverageFileTreeNodeDto,
  QueryFilter,
  QueryResult,
} from '@flowqa/shared';

type CoverageFileQueryRequest = {
  page: number;
  pageSize: number;
  filters?: QueryFilter[];
  sorts?: Array<{ field: string; direction: 'asc' | 'desc' }>;
};

type CoverageFileTreeQueryRequest = CoverageFileQueryRequest & {
  treePath?: string | null;
};

export const queryCoverageFiles = async (
  input: CoverageFileQueryRequest,
  orgId?: string | null,
): Promise<QueryResult<CoverageFileDto>> => {
  const result = await apiClient.post<QueryResult<CoverageFileDto>>('coverage-files/query', input, {
    orgId,
  });
  return mapQueryResult(result, mapCoverageFileDto);
};

export const queryCoverageFileTree = async (
  input: CoverageFileTreeQueryRequest,
  orgId?: string | null,
): Promise<QueryResult<CoverageFileTreeNodeDto>> =>
  await apiClient.post<QueryResult<CoverageFileTreeNodeDto>>('coverage-files/tree/query', input, {
    orgId,
  });

export const getCoverageFileById = async (
  id: string,
  orgId?: string | null,
): Promise<CoverageFileDto> =>
  mapCoverageFileDto(await apiClient.get<CoverageFileDto>(`coverage-files/${id}`, { orgId }));
